import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-content flex-1 flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <span className="font-heading text-6xl font-black text-background-300 md:text-8xl">
          404
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面不在了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址（{location.pathname}）没有对应内容，可能是链接已更新。
          去瓜田总览看看正在复盘的事件吧。
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/events"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-list-2-line text-lg"></i>
            进入瓜田总览
          </Link>
          <Link
            to="/"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-home-5-line text-lg"></i>
            返回首页
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}